module.exports = __webpack_public_path__ + "static/logo-5de5ab5ce9a249921b1161df2ae7e571.png";